import { AuthLayout, ForgotPasswordForm } from 'src/features/auth/components';

const ForgotPassword = () => {
    return (
        <AuthLayout>
            <ForgotPasswordForm />
        </AuthLayout>
    );
};

export { ForgotPassword };
